import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { formatViews, getCategoryName, getFeaturedArticles } from "@/lib/content";

export default function FocusSection() {
  const featured = getFeaturedArticles();
  const [main, ...rest] = featured;
  if (!main) return null;

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="max-w-content mx-auto">
        <SectionHeading
          eyebrow="Focus"
          title="今日焦点瓜"
          desc="编辑部为你挑出的几条值得细看的热点，从台前到幕后一次讲清楚。"
          action={{ label: "查看热瓜榜", path: "/rank" }}
        />

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-5">
          <Link
            to={`/article/${main.id}`}
            className="group lg:col-span-7 relative rounded-lg overflow-hidden min-h-[320px] md:min-h-[460px] flex flex-col justify-end cursor-pointer"
          >
            <div className="absolute inset-0">
              <img
                src={main.cover}
                alt={main.title}
                title={`${main.title} - 51吃瓜`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/35 to-transparent"></div>
            </div>
            <div className="relative p-6 md:p-8">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                <i className="ri-fire-line"></i>
                {getCategoryName(main.category)}
              </span>
              <h3 className="mt-4 font-heading font-black text-2xl md:text-3xl text-background-50 leading-snug line-clamp-2">
                {main.title}
              </h3>
              <p className="mt-3 text-sm text-background-100/80 leading-relaxed line-clamp-2 max-w-xl">
                {main.excerpt}
              </p>
              <div className="mt-4 flex items-center gap-4 text-xs text-background-100/70">
                <span>{main.author}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {formatViews(main.views)}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-time-line"></i>
                  {main.readMinutes} 分钟
                </span>
              </div>
            </div>
          </Link>

          <div className="lg:col-span-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-5">
            {rest.slice(0, 2).map((item) => (
              <Link
                key={item.id}
                to={`/article/${item.id}`}
                className="group relative rounded-lg overflow-hidden min-h-[220px] flex flex-col justify-end cursor-pointer"
              >
                <div className="absolute inset-0">
                  <img
                    src={item.cover}
                    alt={item.title}
                    title={`${item.title} - 51吃瓜`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/30 to-transparent"></div>
                </div>
                <div className="relative p-5">
                  <span className="text-xs text-accent-300">
                    {getCategoryName(item.category)} · {item.publishedAt}
                  </span>
                  <h3 className="mt-2 font-heading font-bold text-lg text-background-50 leading-snug line-clamp-2">
                    {item.title}
                  </h3>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}